import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SortEvent } from 'primeng/api';
import { OwnerModel } from 'src/app/model/ownerModel.model';
import { ParcelModel } from 'src/app/model/parcelModel.model';
import { RefAddressModel } from 'src/app/model/refAddressModel.model';
import { ApoQueryable } from 'src/app/modules/apo/models/apoRecord.model';

import {
  getAddressDescription,
  getOwnerAddressDescription,
  getOwnerDescription,
  getOwnerNameDescription,
  getParcelDescription,
  getRefAddressStreetDescription
} from 'src/app/modules/apo/util/apo.util';
import { AddressModel } from 'src/app/modules/shared/model/addressModel.model';
import { HTML_ELEMENT } from 'src/app/modules/shared/model/htmlElements.const';
import { isStringNullOrWhiteSpace } from 'src/app/util/StringUtil';
import { Column } from '../../../shared/model/column.model';
import { ConditionType } from '../../models/apo.const';
import { getConditionTooltip } from '../../util/condition.util';

@Component({
  selector: 'apo-search-results-panel',
  templateUrl: './apo-search-results-panel.component.html',
  styleUrls: ['./apo-search-results-panel.component.css']
})
export class SearchResultsPanelComponent implements OnInit {

  @Input() sectionTitle: string;

  @Input() searchResults: any[];

  @Input() columnData: Column[];

  @Input() addStreetDescriptionColumn = false;

  @Input() addOwnerNameColumn = false;

  @Input() addOwnerAddressColumn = false;

  @Input() alternateActionLabel = '';

  @Input() showAddButton = true;

  @Output() cancelAction: EventEmitter<void> = new EventEmitter<void>();

  @Output() submitAction: EventEmitter<any[]> = new EventEmitter<any[]>();

  @Output() altAction: EventEmitter<void> = new EventEmitter<void>();

  selectedData: any[];

  conditionType = ConditionType;

  constructor() { }

  ngOnInit(): void {
  }

  getRefAddressDescription(rowData: RefAddressModel) {
    return getRefAddressStreetDescription(rowData);
  }

  getOwnerNameDescription(rowData: OwnerModel) {
    return getOwnerNameDescription(rowData);
  }

  getOwnerAddressDescription(rowData: OwnerModel){
    return getOwnerAddressDescription(rowData).split(HTML_ELEMENT.lineBreak).join(' ');
  }

  sortColumn(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let result = 0; //by default, two null values will be equal

      if (event.field === 'description') { //special sort for the description column
        const val1 = getRefAddressStreetDescription(data1);
        const val2 = getRefAddressStreetDescription(data2);
        result = val1.localeCompare(val2);
      } else if (event.field === 'OwnerName') { //special sort for the description column
        const val1 = getOwnerNameDescription(data1);
        const val2 = getOwnerNameDescription(data2);
        result = val1.localeCompare(val2);
      } else if (event.field === 'OwnerAddress') { //special sort for the OwnerAddress column
        const val1 = getOwnerAddressDescription(data1);
        const val2 = getOwnerAddressDescription(data2);
        result = val1.localeCompare(val2);
      } else {

        const value1 = data1[event.field];
        const value2 = data2[event.field];

        if (value1 == null && value2 != null) {
          result = -1;
        } else if (value1 != null && value2 == null) {
          result = 1;
        } else if (value1 == null && value2 == null) {
          result = 0;
        } else if (typeof value1 === 'string' && typeof value2 === 'string') {
          result = value1.localeCompare(value2);
        } else {
          result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
        }
      }
      return (event.order * result);
    });
  }

  hasCondition(col: ApoQueryable, condType: ConditionType): boolean {
    let flag = false;

    if (col && col.hasOwnProperty('hightestCondition')) {
      flag = col.hightestCondition?.impactCode.toUpperCase() === condType;
    }

    return flag;
  }

  cancelClick(event) {
    this.cancelAction.emit();
  }

  //special bindable click for navigation
  altClick(event: Event) {
    this.altAction.emit();
  }

  submitRows() {
    this.submitAction.emit(this.selectedData);
    this.selectedData = [];
  }

  getTooltip(apoRecord: ApoQueryable): string {
    if (apoRecord.hightestCondition) {
      return getConditionTooltip(apoRecord);
    } else if (Object.getPrototypeOf(apoRecord) === AddressModel.prototype){
      return getAddressDescription(apoRecord as AddressModel);
    } else if (Object.getPrototypeOf(apoRecord) === ParcelModel.prototype){
      return getParcelDescription(apoRecord as ParcelModel);
    } else if (Object.getPrototypeOf(apoRecord) === OwnerModel.prototype){
      return getOwnerDescription(apoRecord as OwnerModel);
    }
    return $localize`Select a Record Column`;
  }
}
